import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './styles/desertFlora.css'
import './styles/routingWorkbench.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './reducers/rootReducer'
import { persistStore, persistReducer } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import storage from 'redux-persist/lib/storage'

const persistWhitelist = ['url', 'user', 'authenticated', 'theme', 'perms']

const persistConfig = {
  key: 'root',
  storage,
  version: 2,
  whitelist: persistWhitelist,
  migrate: (state) => {
    if (!state) return Promise.resolve(state)
    const filteredState = persistWhitelist.reduce((nextState, key) => {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        nextState[key] = state[key]
      }
      return nextState
    }, {})
    return Promise.resolve(filteredState)
  }
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
let store = createStore(persistedReducer)
let persistor = persistStore(store)

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <App />
    </PersistGate>
  </Provider>,
document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
